export enum RiderSourceTypeEnum {
    None = 0,
    ImportFromFile = 1,
    CreateByAdmin = 2,
    MobileApp = 3
}
